const fromSalonCoreToDto = (dto) =>
  dto
    ? {
        hide_deleted_stylist_column: dto.hideDeletedStylistColumn,
        // TODO: add all the rest of the fields here
      }
    : void 0;

export default fromSalonCoreToDto;
